import React, { useMemo } from "react";
import Box from "@material-ui/core/Box";
import { Switch, Route, Redirect } from "react-router-dom";
import { useExperimentIsVariant, useBusinessExperimentIsVariant } from "@capone/experiments";
import { ContentBlock } from "halifax";
import { getConfigTenant } from "@capone/common";
import {
  PRICE_PREDICTION_PRICE_WATCH_BODY,
  PRICE_MATCH_GUARANTEE_BODY,
  HOTEL_CFAR_TITLE,
  HOTEL_CFAR_SUBTITLE,
  HOTEL_CFAR_BODY,
  HOTEL_CFAR_TABLE,
} from "redmond";
import {
  PATH_PRICE_PREDICTION_PRICE_WATCH,
  PATH_PRICE_DROP_PROTECTION,
  PATH_CANCEL_FOR_ANY_REASON,
  PATH_PRICE_MATCH_GUARANTEE,
  PATH_SITE_TERMS_OF_USE,
  PATH_TERMS_OF_SERVICE,
  PATH_HOME,
  PATH_DISRUPTION_PROTECTION,
  PATH_TRAVEL_CREDITS,
  PATH_HOTEL_CANCEL_FOR_ANY_REASON,
} from "../../../utils/paths";

import {
  PRICE_MATCH_GUARANTEE_TITLE,
  PRICE_MATCH_GUARANTEE_SUBTITLE,
} from "./TextConstants/bestPriceGuaranteeTextConstant";

import {
  TERMS_OF_SERVICE_TITLE,
  TERMS_OF_SERVICE_SUBTITLE,
  TERMS_OF_SERVICE_BODY,
} from "./TextConstants/termsOfServiceTextConstant";
import {
  SITE_TERMS_OF_USE_TITLE,
  SITE_TERMS_OF_USE_SUBTITLE,
  SITE_TERMS_OF_USE_BODY,
} from "./TextConstants/siteTermOfUseTextConstant";

import {
  PRICE_PREDICTION_PRICE_WATCH_TITLE,
  PRICE_PREDICTION_PRICE_WATCH_SUBTITLE,
} from "./TextConstants/pricePredictionPriceWatchTextConstants";

import {
  TRAVEL_CREDITS_TITLE,
  TRAVEL_CREDITS_SUBTITLE,
} from "../capone/TextConstants/travelCreditsTextContant";
import {
  AVAILABLE,
  TRAVEL_WALLET_CREDIT_EXPERIMENT,
} from "../../../context/experiments";
import { CORP_TRAVEL_CREDITS_BODY } from "./TextConstants/travelCreditsTextConstant";

interface IBodyProps {
  language: string;
}

const Body = (_props: IBodyProps) => {
  const isInIntraReferralAvailable100Variant = useBusinessExperimentIsVariant(
    "corp-intra-business-referrals",
    "available-100"
  );
  const offerAmount = isInIntraReferralAvailable100Variant ? 100 : 50;

  const getBodyContent = (path: string) => {
    switch (path) {
      case PATH_PRICE_PREDICTION_PRICE_WATCH:
        return [
          PRICE_PREDICTION_PRICE_WATCH_TITLE,
          PRICE_PREDICTION_PRICE_WATCH_SUBTITLE,
          PRICE_PREDICTION_PRICE_WATCH_BODY(getConfigTenant()),
        ];
      case PATH_PRICE_MATCH_GUARANTEE:
        return [
          PRICE_MATCH_GUARANTEE_TITLE,
          PRICE_MATCH_GUARANTEE_SUBTITLE,
          PRICE_MATCH_GUARANTEE_BODY,
        ];
      case PATH_HOTEL_CANCEL_FOR_ANY_REASON:
        return [
          HOTEL_CFAR_TITLE,
          HOTEL_CFAR_SUBTITLE,
          HOTEL_CFAR_BODY + HOTEL_CFAR_TABLE,
        ];
      case PATH_SITE_TERMS_OF_USE:
        return [
          SITE_TERMS_OF_USE_TITLE,
          SITE_TERMS_OF_USE_SUBTITLE,
          SITE_TERMS_OF_USE_BODY,
        ];
      case PATH_TRAVEL_CREDITS:
        return [
          TRAVEL_CREDITS_TITLE,
          TRAVEL_CREDITS_SUBTITLE,
          CORP_TRAVEL_CREDITS_BODY,
        ];
      case PATH_TERMS_OF_SERVICE:
      default:
        return [
          TERMS_OF_SERVICE_TITLE,
          TERMS_OF_SERVICE_SUBTITLE,
          TERMS_OF_SERVICE_BODY(offerAmount),
        ];
    }
  };

  const sectionToScroll = useMemo(
    () => window.location.hash.substring(1),
    [window.location.hash]
  );

  const renderTerms = (path: string) => {
    const [title, subtitle, body] = getBodyContent(path);
    return <ContentBlock {...{ title, subtitle, body, sectionToScroll }} />;
  };

  const isTravelWalletCreditsExperiment = useExperimentIsVariant(
    TRAVEL_WALLET_CREDIT_EXPERIMENT,
    AVAILABLE
  );

  return (
    <Box className="terms-body-container corporate">
      <Switch>
        <Route path={PATH_PRICE_DROP_PROTECTION} exact>
          <Redirect to={PATH_TERMS_OF_SERVICE} />
        </Route>
        <Route path={PATH_DISRUPTION_PROTECTION} exact>
          <Redirect to={`${PATH_TERMS_OF_SERVICE}#flight-disruption-rebooking`} />
        </Route>
        <Route path={PATH_CANCEL_FOR_ANY_REASON} exact>
          <Redirect to={PATH_TERMS_OF_SERVICE} />
        </Route>
        <Route
          path={[
            PATH_PRICE_PREDICTION_PRICE_WATCH,
            PATH_HOTEL_CANCEL_FOR_ANY_REASON,
            PATH_PRICE_MATCH_GUARANTEE,
            PATH_SITE_TERMS_OF_USE,
            PATH_TERMS_OF_SERVICE,
            PATH_HOME,
            ...(isTravelWalletCreditsExperiment ? [PATH_TRAVEL_CREDITS] : []),
          ]}
          render={(props) => renderTerms(props.location.pathname)}
          exact
        />
      </Switch>
    </Box>
  );
};

export default Body;
